import * as React from "react";
import { IdStyles } from "../../less/IdStyles";
import { utilNumber } from "../../utils/utilNumber";
import { ProfilePicture } from "../player-profile/ProfilePicture";
export var RankTableRow = function (_a) {
    var rowClassName = _a.rowClassName, profilePictureName = _a.profilePictureName, level = _a.level, rankValue = _a.rankValue, rank = _a.rank, name = _a.name, onRowClick = _a.onRowClick;
    var cursorClass = onRowClick !== undefined ? "with-button-cursor-hover" : "";
    return (React.createElement("div", { className: rowClassName + " tr " + cursorClass, onClick: onRowClick },
        React.createElement("div", { className: "td" }, rank),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td td--pp" },
            profilePictureName && (React.createElement(ProfilePicture, { profilePictureName: profilePictureName, profilePictureClassName: "ranking-profile-pic", profilePictureSize: IdStyles.ProfilePictureX_small })),
            name),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td" }, level),
        React.createElement("div", { className: "td__divider" }),
        React.createElement("div", { className: "td" }, utilNumber.format(rankValue))));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/ranking/RankTableRow.tsx
// module id = 2744
// module chunks = 3